import { getSiblings, findAncestorByAttr } from '../common/utils';
import {Timeout} from "../common/const";

// смена отображения карточек каталога
const initCatalogView = (attr) => {
    const listing = document.querySelector(`[data-cat-view-listing]`);
    if (!listing || !attr) return;

    const products = listing.querySelectorAll(`.product`);
    const btn = document.querySelector(`[data-cat-view="${attr}"]`);
    btn.classList.add(`active`);
    getSiblings(btn)[0].classList.remove(`active`);

    if (attr === `table`) {
        products.forEach((product) => {
            product.classList.remove(`product--row`);
            product.parentNode.classList.remove(`grid__block--full`);
        });
    } else if (attr === `list`) {
        products.forEach((product) => {
            product.classList.add(`product--row`);
            product.parentNode.classList.add(`grid__block--full`);
        });
    }
}


export const initBtnsClick = () => {
    document.addEventListener(`click`, (e) => {
        const target = e.target;

        // очистить поле ввода
        if (target && target.closest(`[data-clear-input]`)) {
            const input = getSiblings(target).find(el => el.nodeName === 'INPUT' && el.type !== `hidden`);

            if (input) {
                input.value = '';
                // const event = new CustomEvent(`input`, {
                //     bubbles: true,
                //     cancelable: false
                // });
                input.dispatchEvent(new CustomEvent(`input`, {
                    bubbles: true,
                    cancelable: false
                }));
                input.focus();
            }
        }

        // добавить в корзину
        if (target && target.closest(`[data-cart-add]`)) {
            if (target.getAttribute(`data-cart-add`) === `link`) {
                if (target.classList.contains(`active`)) {
                    window.location.href = `cart.html`;
                }

                target.classList.add(`active`);
            }
            else if (target.getAttribute(`data-cart-add`) === `multiplier`) {
                if (!target.classList.contains(`active`)) {
                    target.classList.add(`active`);

                    const parent = findAncestorByAttr(target, `data-product-id`);
                    const id = parent.getAttribute(`data-product-id`);
                    const products = document.querySelectorAll(`[data-product-id="${id}"]`);
                    products.forEach((product) => {
                        const productInput = product.querySelector(`[data-multiplier-input]`);
                        if (!productInput) return;

                        product.querySelector(`[data-cart-add]`).classList.add(`active`);
                        productInput.value = 1;
                    });
                }
            }
            else {
                // target.classList.toggle(`active`);
            }
        }

        // увеличить/уменьшить количество
        if (target && target.closest(`[data-multiplier]`)) {
            const attr = target.getAttribute(`data-multiplier`);
            const parent = findAncestorByAttr(target, `data-product-id`);
            const productId = parent.getAttribute(`data-product-id`);
            const products = document.querySelectorAll(`[data-product-id="${productId}"]`);
            const input = getSiblings(target).find(el => el.nodeName === 'INPUT');
            const max = parseInt(input.getAttribute(`data-multiplier-max`), 10);
            const min = parseInt(input.getAttribute(`data-multiplier-min`), 10);
            let val = parseInt(input.value, 10);

            if (attr === `minus` && val >= min) {
                val--;

                products.forEach((product) => {
                    const productInput = product.querySelector(`[data-multiplier-input]`);
                    if (!productInput) return;

                    productInput.value = val;

                    if (val < min) {
                        const parent = product.querySelector(`[data-cart-add]`);
                        if (parent) parent.classList.remove(`active`);
                    }
                });

            } else if (attr === `plus` && val < max) {
                val++;

                products.forEach((product) => {
                    const productInput = product.querySelector(`[data-multiplier-input]`);
                    if (!productInput) return;

                    productInput.value = val;
                });
            }
        }

        // смена отображения карточек каталога
        if (target && target.closest(`[data-cat-view]`)) {
            const attr = target.getAttribute(`data-cat-view`);
            initCatalogView(attr);

            $.cookie('catalog-view', attr, { expires: 7 });
        }

        // закрыть попап
        if (target && target.closest(`[data-popup-close]`)) {
            $(`.popup`).fadeOut(Timeout.ANIMATION_TOGGLE);
        }

        // открыть список магазинов на карте
        if (target && target.closest(`[data-order-btn]`)) {
            const attr = target.getAttribute(`data-order-btn`);
            target.classList.add(`active`);
            getSiblings(target)[0].classList.remove(`active`);

            if (attr === `list` || attr === `map`) {
                $(`[data-toggle-btn="map-list"]`).trigger(`click`);
            }
        }
    });



    // загрузка страницы
    window.addEventListener(`load`, () => {
        const catalogView = $.cookie('catalog-view');
        initCatalogView(catalogView);
    });
}

// $(`body`).on(`click`, `[data-cart-add]`, function() {
//     const id = $(this).closest(`[data-product-id]`).attr(`data-product-id`);
//     const $product = $(`[data-product-id="${id}"]`);
//     $product.find(`[data-cart-add-wrap]`).addClass(`active`);
//     $product.find(`[data-multiplier-input]`).val(1);
// });

// изменение количества в карточке товара в листинге на + и -

// изменение значения в поле + -
// $(`body`).on(`change`, `[data-multiplier-input]`, function() {
//     let val = parseInt($(this).val(), 10);
//     const $cartBlock = $(this).closest(`[data-cart-add-block]`);
//
//     if (val === 0 && $cartBlock.length) {
//         $(`[data-cart-add-block=${$cartBlock.attr(`data-cart-add-block`)}]`).removeClass(`active`);
//     }
// });
